import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, Switch } from "react-router-dom";
import NavbarTop from "../components/navbar/NavbarTop";
import NavbarVertical from "../components/navbar/NavbarVertical";
import Footer from "../components/common/Footer";
import loadable from "@loadable/component";
import AppContext from "../context/Context";
import { getPageName } from "../helpers/utils";
import apiCall from "../services/apiCall";
import { Alert } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons";
import ButtonIcon from "../components/common/ButtonIcon";
import ModalCustom from "../components/common/ModalCustom";
import AccountRecoveryModel from "../components/admin-user-common/AccountRecovery/AccountRecoveryModel";

const AdminDashboardRoutes = loadable(() => import("./AdminDashboardRoutes"));
const AdminDashboardLayout = ({ location }) => {
  const {
    isFluid,
    isVertical,
    navbarStyle,
    remember,
    rememberEmail,
    rememberPass,
    loginUserDetails,
  } = useContext(AppContext);

  const isKanban = getPageName("kanban");
  const [recoveryStatus, setRecoveryStatus] = useState(false);
  const [showRecoveryModel, setShowRecoveryModel] = useState(false);
  useEffect(() => {
    AdminDashboardRoutes.preload();
    if (remember) {
      localStorage.setItem(
        "remember",
        JSON.stringify({
          email: rememberEmail,
          password: rememberPass,
        })
      );
    } else {
      localStorage.removeItem("remember");
    }
    // console.log("remember", loginUserDetails);
  }, [remember]);

  const onDismissAccountRecovery = () => {
    localStorage.removeItem("accountRecoveryModel");
    setRecoveryStatus(false);
    setShowPaymentModal(false);
  };

  return (
    <div className={isFluid || isKanban ? "container-fluid" : "container"}>
      {isVertical && (
        <NavbarVertical isKanban={isKanban} navbarStyle={navbarStyle} />
      )}
      <div className="content">
        {!window.location.href.includes("Chatbox") ? <NavbarTop /> : null}
        <Switch>
          <AdminDashboardRoutes />
        </Switch>
        {!window.location.href.includes("Chatbox")
          ? !isKanban && <Footer />
          : null}
      </div>
      {/* <SidePanelModal path={location.pathname} /> */}
    </div>
  );
};

AdminDashboardLayout.propTypes = { location: PropTypes.object.isRequired };

export default AdminDashboardLayout;
